import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { IPriceLevelsFeature } from './price-levels.feature.state';
import { PriceLevelsState } from './price-levels.state';

export const getPriceLevelsState: MemoizedSelector<IPriceLevelsFeature, PriceLevelsState> = createFeatureSelector<PriceLevelsState>(
  nameof<IPriceLevelsFeature>('priceLevelsFeature')
);

export const getIsLoading = createSelector(getPriceLevelsState, (state: PriceLevelsState) => state.isLoading);
export const getFailures = createSelector(getPriceLevelsState, (state: PriceLevelsState) => state.failures);
export const getPriceLevels = createSelector(getPriceLevelsState, (state: PriceLevelsState) => state.priceLevels);
